<template>
  <div v-loading="loading" class="container_padding">
    <div v-if="question && question.question" class="question">
      <Question :question="question" :showResult="showResult" :answerDetail="answerDetail" isResult :index="question.index"></Question>

      <!-- 模擬考試btn -->
      <div v-if="showBtn" class="next_btn">
        <mBtn
          v-if="canSubmitTest"
          @click="submitTest"
          :loading="loading"
        >{{$t('message.submit_test')}}</mBtn>
        <mBtn
          v-if="showResult && !canSubmitTest"
          @click="nextQuestion"
          :loading="loading"
        >{{$t('message.next_question')}}</mBtn>
        <mBtn
          v-if="!showResult && !canSubmitTest"
          @click="submit"
          :loading="loading"
          :disabled="question.answer == null || (questionType =='SHORT_ANSWER' && question.answer == '') || (questionType =='MULTIPLE_CHOICE' && question.answer == '')"
        >{{$t('message.confirm')}}</mBtn>
      </div>
      <!-- 移動端顯示的對錯框 -->
      <div v-if="showResult && $store.state.isMobile" class="correct">
        <div
          v-if="!answerDetail.correct && answerDetail.question.questionType != 'TRUE_OR_FALSE'"
          :class="answerDetail.question.questionType == 'SHORT_ANSWER' ? 'correct_short_answer' : 'correct_answer'"
        >{{answerDetail.question.answerAlias || answerDetail.question.answer || answerDetail.question[`answer${$t('message.lan')}`] | sortLetter}}</div>
        <div
          v-if="!answerDetail.correct && answerDetail.question.questionType == 'TRUE_OR_FALSE'"
          class="correct_answer"
        >
          <img src="../../../assets/web/Wrong.png" alt />
        </div>
        <div v-if="answerDetail.correct" class="correct_answer">
          <img src="../../../assets/web/Correct.png" alt />
        </div>
        <div
          class="correct_text"
        >{{answerDetail.correct ? $t('message.correct_answer'):answerDetail.question.questionType == 'TRUE_OR_FALSE'?$t('message.wrong_answer'):$t('message.right_key')}}</div>
      </div>
      <!-- 查看題目btn -->
      <div v-if="!showBtn" class="back_btn">
        <mBtn @click="$router.go(-1)">{{$t('message.back')}}</mBtn>
      </div>
    </div>
  </div>
</template>

<script>
import UserAssessmentsAPI from "../../../api/UserAssessmentsAPI";
import mBtn from "../../../components/mBtn";
import Question from "../../../components/Question";
import { basePathUrl } from "../../../api/axios";
export default {
  components: { mBtn, Question },
  data() {
    return {
      question: {},
      loading: false,
      questionIndex: 0,
      showResult: false,
      questionCount: null,
      questionNum: 0,
      canSubmitTest: false,
      answerDetail: {},
      showBtn: true,
      basePathUrl: basePathUrl,
      audioUrl: null,
      soundLocale: "TW"
    };
  },
  watch: {
    questionNum() {
      const questionCount = parseInt(sessionStorage.getItem("questionCount"));
      const questionNum = parseInt(sessionStorage.getItem("questionNum"));

      this.canSubmitTest = Number(questionCount) == questionNum ? true : false;
    }
    // "question.answer"() {
    //   console.log("question.answer");
    //   const question = this.question;
    //   const answer = question.answer;

    // }
  },
  computed: {
    questionType() {
      const question = this.question;
      return question && question.question && question.question.questionType;
    },
    showMultiplCorrect() {
      return function(index) {
        return this.showResult &&
          this.answerDetail.question.randomAnswer.includes(index)
          ? true
          : false;
      };
    }
  },
  methods: {
    // 獲取題目
    findNextQuestion() {
      const locale = this.$i18n.locale;
      this.loading = true;
      const questionNum = parseInt(sessionStorage.getItem("questionNum"));
      // const idx = questionNum == 0 ? 0 : questionNum - 1;
      // console.log(idx);
      UserAssessmentsAPI.findNextQuestion(questionNum, locale)
        .then(res => {
          // console.log(res);
          this.loading = false;
          if (!res) {
            this.$message({
              message: this.$t("message.no_question"),
              type: "error"
            });
          } else {
            if (
              res.question &&
              res.question.questionType == "MULTIPLE_CHOICE"
            ) {
              res.answer = [];
            } else {
              res.answer = null;
            }
            this.question = res;
            this.audioUrl = `${this.basePathUrl}question/audios/${
              res.question.id
            }?lang=${this.soundLocale == "CN" ? "ZH_CN" : this.soundLocale == "E" ? "EN" : this.soundLocale == "P" ? "PT" : "ZH_TW"}`;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$error(err);
          console.log(err);
        });
    },
    // 提交題目
    submit() {
      let question = JSON.parse(JSON.stringify(this.question));
      let questionAnswer = question.question;
      const randomAnswer = questionAnswer.randomAnswer;
      const randomChoices = questionAnswer.randomChoices;
      if (questionAnswer.questionType == "MULTIPLE_CHOICE") {
        const answer = question.answer;
        let myAnswer = [];
        // 處理答案排序問題
        for (let i = 0; i < randomChoices.length; i++) {
          if (answer.includes(randomChoices[i])) {
            myAnswer.push(randomChoices[i]);
          }
        }
        // console.log('myAnswer',myAnswer);
        question.answer =
          myAnswer.length > 0
            ? myAnswer.toString().replace(/\s/gi, "")
            : question.answer.toString().replace(/\s/gi, "");
      }
      // 刪除多餘數據
      delete questionAnswer.localeText;
      delete questionAnswer.localeChoices;
      delete questionAnswer.randomAnswer;
      delete questionAnswer.answerAlias;
      delete questionAnswer.randomChoices;
      delete question.correct;
      delete questionAnswer.normalIndexOfRandomChoice;

      // console.log(question);

      // console.log(question);
      const locale = this.$i18n.locale;
      this.loading = true;
      UserAssessmentsAPI.answer(question, question.id, locale)
        .then(res => {
          this.loading = false;
          this.showResult = true;
          this.questionNum = parseInt(this.questionNum) + 1;
          this.answerDetail = res;
          sessionStorage.setItem("questionNum", this.questionNum);
          console.log(res);
        })
        .catch(err => {
          this.loading = false;
          this.$error(err);
          console.log(err);
        });
    },
    nextQuestion() {
      this.showResult = false;
      this.findNextQuestion();
    },
    // 提交試卷
    submitTest() {
      // console.log("submitTest");
      const locale = this.$i18n.locale;
      UserAssessmentsAPI.submit(this.question.userAssessmentId, locale)
        .then(res => {
          this.$message({
            message: this.$t("message.submit_success"),
            type: "success"
          });
          sessionStorage.removeItem("testing");
          sessionStorage.removeItem("questionCount");
          sessionStorage.removeItem("questionNum");
          this.$store.commit("changTestResult", res);
          this.$router.push({
            path: "/learning/testresult",
            query: {
              resultId: res.id,
              resultCourseId: res.courseVersionId,
              submit: 1
            }
          });
        })
        .catch(err => {
          // this.$error(err);
          console.log(err);
          this.$message({
            message: this.$t("message.submit_error"),
            type: "error"
          });
        });
    },
    get() {
      this.findNextQuestion();
    }
  },
  created() {
    this.soundLocale = localStorage.getItem("sound");
    const question = this.$route.params.question;
    if (question) {
      const data = question.question;
      if (data.questionType == "TRUE_OR_FALSE") {
        question.answer = question.answer == "true" ? true : false;
      } else if (data.questionType == "MULTIPLE_CHOICE") {
        const answer = [...question.answer.split(", ")];
        console.log(answer);
        const arr = [];
        for (let item in answer) {
          arr.push(data.randomChoices[parseInt(answer[item])]);
        }
        question.answer = arr;
      } else if (data.questionType == "SINGLE_CHOICE") {
        const answer = parseInt(question.answer);
        question.answer = data.randomChoices[answer];
      }
      this.question = question;
      this.answerDetail = question;
      this.showResult = true;
      this.showBtn = false;
      return;
    }

    const testing = sessionStorage.getItem("testing");
    const questionCount = sessionStorage.getItem("questionCount");
    const questionNum = sessionStorage.getItem("questionNum");
    this.questionCount = questionCount;
    this.questionNum = questionNum ? questionNum : 0;
    if (!questionNum) {
      sessionStorage.setItem("questionNum", 0);
    }
    // console.log(!testing);
    // console.log(!questionCount);
    if (!testing || !questionCount) {
      this.$router.push("/learning/record");
      return;
    }

    this.get();
  }
};
</script>

<style lang="scss" scoped>
.next_btn {
  text-align: right;
  margin: 28px 0;
}
/deep/.el-radio{
  margin-left: 40px;
}
/deep/.el-checkbox{
  margin-left: 40px;
  .result_icon{
    left: -40px;
  }
}
</style>